// eslint-disable-next-line wix-custom-rules/wixstores-file-names
import {
  ComWixEcommerceValidationsSpiV1TargetLineItemSuggestedFix,
  ComWixEcommerceValidationsSpiV1TargetNameInLineItem,
  ViolationLineItemTargetFragment,
} from '../../../gql/graphql';

export class ViolationLineItemTargetModel {
  public name?: ViolationLineItemTargetName;
  public id?: string;
  public suggestedFix?: SuggestedFix;
  constructor(lineItemTarget?: ViolationLineItemTargetFragment) {
    this.name = lineItemTarget?.name
      ? toViolationLineItemTargetName(lineItemTarget?.name)
      : /* istanbul ignore next */ undefined;
    this.id = lineItemTarget?.id ?? undefined;
    this.suggestedFix = lineItemTarget?.suggestedFix ? toSuggestedFix(lineItemTarget.suggestedFix) : undefined;
  }
}

export enum SuggestedFix {
  removeLineItem = 'REMOVE_LINE_ITEM',
}

export enum ViolationLineItemTargetName {
  lineItemDefault = 'LINE_ITEM_DEFAULT',
}

const toViolationLineItemTargetName = (otherTargetName: ComWixEcommerceValidationsSpiV1TargetNameInLineItem) => {
  // eslint-disable-next-line sonarjs/no-small-switch
  switch (otherTargetName) {
    case ComWixEcommerceValidationsSpiV1TargetNameInLineItem.LINE_ITEM_DEFAULT:
      return ViolationLineItemTargetName.lineItemDefault;
    /* istanbul ignore next */ default:
      return undefined;
  }
};

const toSuggestedFix = (suggestedFix: string) => {
  // eslint-disable-next-line sonarjs/no-small-switch
  switch (suggestedFix) {
    case ComWixEcommerceValidationsSpiV1TargetLineItemSuggestedFix.REMOVE_LINE_ITEM:
      return SuggestedFix.removeLineItem;
    /* istanbul ignore next */ default:
      return undefined;
  }
};
